<template>
  <div
    class="spriteRightKey"
    v-if="boxData.judgeBox"
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }"
    @mousedown="stopDocument($event)"
  >
    <div class="spriteRightKey_body">
      <div
        @click="cut()"
        v-if="actionData.cut !== 0"
        :class="{'disable': actionData.cut === 1}"
      >剪切&nbsp;&nbsp;&nbsp;ctrl+x</div>
      <div
        @click="copy()"
        v-if="actionData.copy !== 0"
        :class="{'disable': actionData.copy === 1}"
      >复制&nbsp;&nbsp;&nbsp;ctrl+c</div>
      <div
        @click="paste($event)"
        v-if="actionData.paste !== 0"
        :class="{'disable': actionData.paste === 1}"
      >粘贴&nbsp;&nbsp;&nbsp;ctrl+v</div>
      <div
        @click="removeSprite()"
        v-if="actionData.removeSprite !== 0"
        :class="{'disable': actionData.removeSprite === 1}"
      >删除&nbsp;&nbsp;&nbsp;Delete</div>
      <div
        @click="moveSprites(false)"
        v-if="actionData.moveBottom !== 0"
        :class="{'disable': actionData.moveBottom === 1}"
      >置于底层</div>
      <div
        @click="moveSprites(true)"
        v-if="actionData.moveTop !== 0"
        :class="{'disable': actionData.moveTop === 1}"
      >置于顶层</div>
      <div
        @click="openSpriteBox()"
        v-if="false && actionData.openSpriteBox !== 0"
        :class="{'disable': actionData.openSpriteBox === 1}"
      >图层设置</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      boxData: {
        judgeBox: false, // 控制盒子开启关闭
        Zindex: 0, // 盒子层级
        data: null, // 盒子数据
        fix: {
          // 弹窗位置
          x: 0,
          y: 0
        }
      },
      sprite: {}, // 选中的元素
      actionData: {
        cut: 0, // 0--消失，1--置灰，2--可用
        copy: 0,
        paste: 0,
        removeSprite: 0,
        moveTop: 0,
        moveBottom: 0,
        openSpriteBox: 0
      }
    };
  },
  watch: {
    "boxDatas.firstDatas": function(val, oldval) {
      // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.firstDatas, "sprite_right_key");
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if (this.TOOL && this.boxData.judgeBox) {
        // 打开的操作
        for (let i = 0; i < this.boxDatas.firstDatas.length; i++) {
          if (this.boxDatas.firstDatas[i] !== "sprite_right_key") {
            this.$bus.emit("FeaturesPop_close_vue", {
              name: this.boxDatas.firstDatas[i],
              type: 1
            });
          }
        }
        this.boxData.data = this.dataMsg.sprite_right_key;
        this.sprite = this.boxData.data.sprite;
        this.boxData.Zindex = (this.dataMsg.length + 1) * 5;
        this.boxData.fix.x = this.boxData.data.posx + 15;
        this.boxData.fix.y = this.boxData.data.posy + 15;
        if (this.isClipboardEmpty) {
          this.actionData.paste = 1; // 粘贴 0--消失，1--置灰，2--可用
        } else {
          this.actionData.paste = 2; // 粘贴 0--消失，1--置灰，2--可用
        }
        switch (this.boxData.data.actionType) {
          case "sprite":
            this.actionData.cut = 2; // 0--消失，1--置灰，2--可用
            this.actionData.copy = 2; // 0--消失，1--置灰，2--可用
            this.actionData.removeSprite = 2; // 0--消失，1--置灰，2--可用
            this.actionData.moveTop = 2; // 0--消失，1--置灰，2--可用
            this.actionData.moveBottom = 2; // 0--消失，1--置灰，2--可用
            this.actionData.openSpriteBox = 2; // 0--消失，1--置灰，2--可用
            break;
          case "multiSelect":
          case "tool":
            this.actionData.cut = 0; // 0--消失，1--置灰，2--可用
            this.actionData.copy = 0; // 0--消失，1--置灰，2--可用
            this.actionData.removeSprite = 0; // 0--消失，1--置灰，2--可用
            this.actionData.moveTop = 0; // 0--消失，1--置灰，2--可用
            this.actionData.moveBottom = 0; // 0--消失，1--置灰，2--可用
            this.actionData.openSpriteBox = 2; // 0--消失，1--置灰，2--可用
            break;
        }
      }
    }
  },
  props: ["dataMsg", "boxDatas"],
  computed: {
    ...mapGetters([
      "TOOL",
      "SelectScenes_Msg",
      "TopNav_Size",
      "MaterialPane_Size",
      "isClipboardEmpty"
    ])
  },
  mounted() {},
  methods: {
    stopDocument(e) {
      // 防止事件冒泡
      e.stopPropagation();
    },
    clickFS() {
      this.$bus.emit("FeaturesPop_close_vue", {
        name: "sprite_right_key",
        type: 1
      });
    },
    removeSprite() {
      if (this.actionData.removeSprite !== 2) return;
      this.TOOL.removeSprite(this.boxData.data.sprite.id, true);
      this.clickFS();
    },
    openSpriteBox() {
      if (this.actionData.openSpriteBox !== 2) return;

      this.$bus.emit("FeaturesPop_vue", {
        name: "sprites",
        posx: this.boxData.fix.x,
        posy: this.boxData.fix.y,
        type: 2
      });
      this.clickFS();
    },
    moveSprites(data) {
      if (data) {
        if (this.actionData.moveTop !== 2) return;

        this.TOOL.moveSpriteTo(
          this.boxData.data.sprite.id,
          this.SelectScenes_Msg.sprites.length,
          true
        );
      } else {
        if (this.actionData.moveBottom !== 2) return;

        this.TOOL.moveSpriteTo(this.boxData.data.sprite.id, 0, true);
      }
      this.clickFS();
    },
    copy() {
      if (this.actionData.copy !== 2) return;

      this.$bus.emit("copy");
      this.clickFS();
    },
    cut() {
      if (this.actionData.cut !== 2) return;

      this.$bus.emit("cut");
      this.clickFS();
    },
    paste(event) {
      if (this.actionData.paste !== 2) return;

      this.$bus.emit("paste", event);
      this.clickFS();
    }
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.spriteRightKey {
  position: absolute;
  top: 0;
  left: 0;
  width: 134px;
  height: auto;
  z-index: 35;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  border: 1px solid #d8dee9;
  background: #fff;
  overflow: hidden;
  text-align: left;

  .dragArea {
    background: #d8dee9;
  }

  .spriteRightKey_body {
    background: #fff;
    > div {
      width: 134px;
      height: 36px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 36px;
      letter-spacing: 0px;
      color: #474261;
      transition: all 0.3s;
      text-indent: 23px;
      cursor: pointer;

      &:hover {
        background: #f6f6fc;
      }
    }
  }

  .disable {
    background: #fff !important;
    color: #bebdc9 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/spriteRightKey.vue